export default __webpack_public_path__ + "static/springandsummer (2)-686dd2ecc3d0583e464c2f50fa210c5d.jpeg";